import { useAudio } from "@/app/contexts/AudioContext";
import AudioIcon from "@/app/components/AudioIcon";
import DownloadIcon from "@/app/components/DownloadIcon";
import YoutubeGreyLogo from "@/components/icons/YouTubeGreyLogo";

// The translator's name is kept in the romanisation used by the source
// (aisafetynotes.jp) rather than guessed back into kanji.
export default function PublicationDate() {
  const { togglePlayPause } = useAudio();
  return <div className="font-mono text-[11px] text-transform-uppercase mb-[-4.4rem] mt-[50px]">
    <div className="flex items-center"> <span className="opacity-50">2025年4月3日公開</span>
      <VerticalDivider /> <a target="_blank" href="/ai-2027.pdf" className="flex items-center no-underline opacity-50 hover:opacity-100"> <DownloadIcon /> <span className="ml-2">PDF</span> </a>
      <VerticalDivider /> <span onClick={togglePlayPause} className="cursor-pointer flex items-center opacity-50 hover:opacity-100"> <AudioIcon /> <span className="ml-2">聴く</span></span>
      <VerticalDivider /> <a target="_blank" href="https://www.youtube.com/watch?v=5KVDDfAkRgc" className="flex items-center no-underline opacity-50 hover:opacity-100"> <YoutubeGreyLogo /> <span className="ml-2">観る</span></a>
    </div>
    <div className="mt-2 opacity-50 leading-relaxed">
      本文翻訳: Masayuki Nagai（<a target="_blank" href="https://aisafetynotes.jp/ai-2027" className="underline">AI Safety Notes</a>）
      <span className="mx-1">/</span>
      脚注・図表ラベル・要約ページは ai-2027.com による機械翻訳
    </div>
  </div>
}

const VerticalDivider = () => (
  <div className="w-[1px] h-[11px] bg-black mx-2 opacity-50" />
);
